import { Slot } from '@radix-ui/react-slot'
import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { buttonVariants } from './button-variants'

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, position, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    const testId = `button-${variant || 'default'}-${size || 'default'}-${position || 'default'}`
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, position }), className)}
        data-testid={testId}
        ref={ref}
        {...props}
      />
    )
  },
)
Button.displayName = 'Button'
